import { setJsonItem } from '@/store/nativeStorage'

export function saveUserPlugin(store) {
  savePlugin(store, 'user')
}

export function saveResourcesPlugin(store) {
  savePlugin(store, 'resources')
}

export function saveRequirementsPlugin(store) {
  savePlugin(store, 'requirements')
}

export function saveRequestsPlugin(store) {
  savePlugin(store, 'requests')
}

function savePlugin(store, key) {
  store.subscribe((mutation, state) => {
    setJsonItem(key, state[key])
  })
}
